module.exports = __webpack_public_path__ + "img/google_cn.56765f2d.png";